import React from "react";

const FeaturesInfoComp = ({data}) => {
  return (
    <div className="w-[95vw] border-solid border-[1px] border-[#000000] mx-4 px-6 py-2 rounded-[10px] bg-[#ffffff] text-black">
      <div className="text-normal font-semibold text-black mb-2">Features</div>
      <div className="bulletPointUL text-base font-normal text-black" dangerouslySetInnerHTML={{__html:data}}></div>
    </div>
  );
};

export default FeaturesInfoComp;
